import axios from "axios";
import React, { Component } from "react";
import { DirectionsRenderer, GoogleMap, withGoogleMap, withScriptjs, } from "react-google-maps";
import IntlCurrencyInput from "react-intl-currency-input";
import Modal from "react-modal";
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from "react-places-autocomplete";
import { toast } from "react-toastify";
import swal from "sweetalert";
import BarTitle from "../../components/BarTitle";
import constants from "../../constants";
import { calculatePriceDistance } from "../../services/agent";
import "./styles.css";
import Select from "react-select";
import { Link } from "react-router";
import perfilDefault from '../../assets/profile-default.png';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

const removeDots = (str) => str.replace(/\./g, "");

const MapWithAMarker = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      zoom={parseInt(props.zoom)}
      defaultCenter={{ lat: -34.397, lng: 150.644 }}
    >
      <DirectionsRenderer directions={props.directions} />
    </GoogleMap>
  ))
);

const rideSolicitationdefault = {
  lat_a: parseFloat(localStorage.getItem("latitude")),
  long_a: parseFloat(localStorage.getItem("longitude")),
  lat_b: null,
  long_b: null,
  price: null,
  driver_requested_id: null,
  payment_method: 2,
  service_type: 2,
  dep_address: localStorage.getItem("address"),
  arr_address: null,
  object_size: 0,
};
class RaceSolicitation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      allDrivers: [],
      isOpen: false,
      tableData: [],
      templatesList: [],
      fidelityValue: null,
      searchResult: null,
      price: 0,
      priceTotal: 0,
      priceTotalFormatted: 0,
      priceReturnTax: 0,
      iddriver: null,
      driverData: null,
      noteInput: null,
      purchase_id: 0,
      test: 0,
      directions: null,
      addShipping: true,
      addShippingEntrega: false,
      addShippingDelivery: true,
      addHaveMachine: false,
      directionsInitial: {
        lat: parseFloat(localStorage.getItem("latitude")),
        lng: parseFloat(localStorage.getItem("longitude")),
      },
      directionsFinal: null,
      directionsInfo: null,
      priceDistanceEntrega: null,
      priceDistanceDelivery: null,
      initialAddress: localStorage.getItem("address"),
      finalAddress: null,
      returnTaxEntrega: {},
      returnTaxDelivery: {},
      rideSolicitation: rideSolicitationdefault,
      savedRideSolicitation: rideSolicitationdefault,
      brandSelect: { value: "2", label: "Fidelidade" },
      templateId: 0,
    };

    this.setFilter = this.setFilter.bind(this);
    this.eraseRaceSolicitation = this.eraseRaceSolicitation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFlagChange = this.onFlagChange.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.onAmountChange = this.onAmountChange.bind(this);
    this.updateDirections = this.updateDirections.bind(this);
  }

  _onChange(value) {
    this.setState({ brandSelect: value });
    this.setState({
      rideSolicitation: {
        ...this.state.rideSolicitation,
        payment_method: value.value,
      },
    });
  }

  disableButton = () => {
    this.setState({ disabled: true });
  };

  handleChange = (initialAddress) => {
    this.setState({ initialAddress });
  };

  calculateReturnTax() {
    let priceDistanceDelivery = this.state.priceDistanceDelivery;
    let priceDistanceEntrega = this.state.priceDistanceEntrega;

    let urlCalculateReturnTaxEntrega =
      constants().URL_SERVICE +
      `setting/distancerate/calculate_return_tax/?value=${priceDistanceEntrega.price}&service_type=1`;

    axios.get(urlCalculateReturnTaxEntrega).then((response) => {
      if (this.state.fidelityValue.table == false) {
        this.setState({
          returnTaxEntrega: response.data,
        });
      }
    });

    let urlCalculateReturnTaxDelivery =
      constants().URL_SERVICE +
      `setting/distancerate/calculate_return_tax/?value=${priceDistanceDelivery.price}&service_type=2`;

    axios.get(urlCalculateReturnTaxDelivery).then((response) => {
      if (this.state.fidelityValue.table == false) {
        this.setState({
          returnTaxDelivery: response.data,
        });
      }
    });
  }

  saveJson() {
    const jsonData = this.state.rideSolicitation;
    const createTemplateUrl =
      constants().URL_SERVICE +
      "establishment/establishment/create_template_service/";

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
        "Content-Type": "application/json",
      },
    };
    try {
      axios
        .post(createTemplateUrl, { data_template: jsonData }, customConfig)
        .then((response) => {
          toast.info("Corrida salva com sucesso!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        })
        .catch((error) => console.error(error));
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  clearAll() {
    this.setState({
      addReturnTax: false,
      addHaveMachine: false,
      finalAddress: null,
      directionsFinal: null,
      note: null,
      noteInput: null,
      iddriver: null,
      priceTotal: 0,
      priceTotalFormatted: 0,
      priceReturnTax: 0,
      driverData: null,
      directions: null,
      directionsInitial: {
        lat: parseFloat(localStorage.getItem("latitude")),
        lng: parseFloat(localStorage.getItem("longitude")),
      },
      directionsInfo: null,
      priceDistanceEntrega: null,
      priceDistanceDelivery: null,
      initialAddress: localStorage.getItem("address"),
      returnTaxEntrega: {},
      returnTaxDelivery: {},
      templateId: 0,
    });
    this.setState({
      rideSolicitation: {
        ...this.state.rideSolicitation,
        lat_b: null,
        long_b: null,
        arr_address: null,
        price: null,
        driver_requested_id: null,
        service_type: 2,
        have_machine: false,
      },
    });
  }

  editJson() {
    const jsonData = this.state.rideSolicitation;
    const createTemplateUrl =
      constants().URL_SERVICE + "establishment/establishment/edit_template/";

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
        "Content-Type": "application/json",
      },
    };
    try {
      axios
        .post(
          createTemplateUrl,
          { id_template: this.state.templateId, json: jsonData },
          customConfig
        )
        .then((response) => {
          toast.info("Corrida editada com sucesso!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          this.setState({ templateId: 0 });
        })
        .catch((error) => console.error(error));
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  requestAll() {
    const createRequestUrl =
      constants().URL_SERVICE +
      "establishment/establishment/request_all_templates/";

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
        "Content-Type": "application/json",
      },
    };
    try {
      axios
        .post(createRequestUrl, "", customConfig)
        .then((response) => {
          toast.success("Corridas solicitadas com sucesso!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          delay(100);
          this.setState({ disabled: false });
        })
        .catch((error) => {
          toast.error("Erro: " + error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err.response);
    }
  }

  requestJson() {
    const jsonData = this.state.rideSolicitation;
    const createRequestUrl =
      constants().URL_SERVICE + "service/requestuser/create_request/";

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
        "Content-Type": "application/json",
      },
    };
    try {
      axios
        .post(createRequestUrl, jsonData, customConfig)
        .then((response) => {
          toast.success("Corrida solicitada com sucessoo!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          delay(100);
          this.setState({ disabled: false });
        })
        .catch((error) => {
          toast.error("Erro: " + error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err.response);
    }
  }

  requestSavedJson(id) {
    const jsonData = this.state.savedRideSolicitation;
    const createRequestUrl =
      constants().URL_SERVICE + "service/requestuser/create_request/";

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
        "Content-Type": "application/json",
      },
    };
    try {
      axios
        .post(createRequestUrl, jsonData, customConfig)
        .then((response) => {
          this.solicitionEraseRaceSolicitation(id);
          delay(200);
          toast.success("Corrida solicitada com sucesso!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          delay(100);
          this.setState({ disabled: false });
        })
        .catch((error) => {
          toast.error("Erro: " + error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err.response);
    }
  }

  handleSelect2 = async (address2) => {

    const address = { address: address2 }
    const headers = { headers: { Authorization: "Token " + localStorage.token } }

    axios.post(constants().URL_SERVICE + 'account/address/check_address/', address, headers)
      .then((response) => {
        const data = response.data;

        //Sem google maps
        if (data.code === 1) {
          const latLng = {
            lat: Number(data.details[0].latitude),
            lng: Number(data.details[0].longitude)
          };
          this.setState({
            finalAddress: address2,
            directionsFinal: latLng,
          });
          this.setState({
            rideSolicitation: {
              ...this.state.rideSolicitation,
              lat_b: latLng.lat,
              long_b: latLng.lng,
              arr_address: address2,
            },
          });
          this.updateDirections();
        }
        //Com google maps
        else {
          let addressComponent = null;
          let formattedAddress = null;

          geocodeByAddress(address2)
            .then((results) => {
              addressComponent = results[0].address_components;
              formattedAddress = results[0].formatted_address;
              return getLatLng(results[0]);
            })
            .then((latLng) => {
              this.setState({
                finalAddress: address2,
                directionsFinal: latLng,
              });

              this.setState({
                rideSolicitation: {
                  ...this.state.rideSolicitation,
                  lat_b: latLng.lat,
                  long_b: latLng.lng,
                  arr_address: address2,
                },
              });

              this.updateDirections();

              /*ARMAZENANDO ENDEREÇO NA BASE DE DADOS*/
              const params = {
                completeAddress: formattedAddress,
                addressComponents: addressComponent,
                latitude: latLng.lat,
                longitude: latLng.lng
              }
              axios.post(constants().URL_SERVICE + 'account/address/createAddress/', params, headers)
                .then((response) => {
                  const data = response.data;
                }).catch((error) => {
                  console.error(error);
                })
            })
            .catch((error) => console.error("Error", error));
        }
      }).catch((error) => {
        console.error(error);
      })
  };

  handleAPI = async (e) => {
    this.setState({
      iddriver: e.target.value,
    });
    const url =
      constants().URL_SERVICE + "establishment/establishment/get_drivers_list/";
    await axios
      .get(url, {
        headers: { Authorization: "Token " + localStorage.token },
      })
      .then((response) => {
        this.setState({ allDrivers: response.data.drivers });
      })
      .catch((error) => this.setState({ error: true }));
    let convertToLc = e.target.value;
    let filterData = this.state.allDrivers.filter((e) => {
      let allDriversId = e.id.toString();
      return allDriversId.indexOf(convertToLc) !== -1;
    });
    let filterDriverData = this.state.allDrivers.filter((e) => {
      let allDriversId = e.id.toString();
      return allDriversId == convertToLc;
    });
    if (filterDriverData.length === 0) {
      filterDriverData = null;
    }
    this.setState({
      driverData: filterDriverData,
    });
    this.setState({
      allDrivers: filterData,
    });
  };
  onFlagChange(event) {
    this.setState({
      flag: event.currentTarget.value,
    });
  }

  handleNotes = async (e) => {
    this.setState({
      noteInput: e.target.value,
    });
  };

  handleCloseModal = async (e) => {
    this.setState({
      noteInput: e.target.value,
    });
  };

  onAmountChange(event) {
    let val = removeDots(event.target.value);
    event.target.value = val.replace(/\d{2}$/, (e) => "." + e);
  }

  handleSubmit(event) {
    event.preventDefault();
    const description = this.refs.description.value;

    const makeATransactionUrl =
      constants().URL_SERVICE +
      "establishment/paymentrequest/create_payment_request/";
    let price = null;

    if (this.state.addShipping) {
      if (this.state.addShippingDelivery) {
      }
    }

    let shipping;

    if (this.state.addShipping) {
      if (this.state.addShippingEntrega) {
        shipping = this.state.priceDistanceEntrega;
      }

      if (this.state.addShippingDelivery) {
        shipping = this.state.priceDistanceDelivery;
      }
    }

    let returnTax = null;

    let hasReturnTax = false;

    if (this.state.fidelityValue.table == true) {
      returnTax = 0;
      if (this.state.addReturnTax) {
        hasReturnTax = true;
      }
    } else if (this.state.addReturnTax) {
      hasReturnTax = true;
      if (this.state.addShippingDelivery) {
        returnTax = parseFloat(this.state.returnTaxDelivery.tax_price);
      }

      if (this.state.addShippingEntrega) {
        returnTax = parseFloat(this.state.returnTaxEntrega.tax_price);
      }
    }

    axios
      .post(
        makeATransactionUrl,
        {
          price: this.state.price,
          client_cpf: this.props.location.state.cpf,
          payment_type: 1,
          purchase_id: this.state.purchase_id,
          description: description,
          shipping: this.state.addShipping ? parseFloat(shipping.price) : null,
          initialAddress: this.state.addShipping
            ? this.state.initialAddress
            : null,
          finalAddress: this.state.addShipping ? this.state.finalAddress : null,
          returnTax: returnTax,
          has_return_tax: hasReturnTax,
        },
        { headers: { Authorization: "Token " + localStorage.token } }
      )
      .then((response) => {
        toast.success("Solicitação efetuada com sucesso!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        if (this.state.addShipping) {
          swal("Solicitação criada com sucesso!", {
            buttons: {
              cupom: {
                text: "Imprimir cupom",
                value: "cupom",
              },
              catch: {
                text: "Ir para tela de solicitações",
                value: "catch",
              },
              cancel: "Fechar",
            },
          }).then((value) => {
            switch (value) {
              case "cupom":
                const win = window.open(
                  `/#/render-cupom/${response.data.id}`,
                  "_blank"
                );
                win.focus();
                this.props.router.push("/home/solicitations/");
                break;

              case "catch":
                this.props.router.push("/home/solicitations/");
                break;
            }
          });
        } else {
          this.props.router.push("/home/solicitations/");
        }
      })
      .catch((error) => console.error(error));
  }

  updateDirections() {
    if (this.state.directionsInitial && this.state.directionsFinal) {
      let initial = this.state.directionsInitial;
      let final = this.state.directionsFinal;

      const directionsService = new window.google.maps.DirectionsService();

      const origin = { lat: initial.lat, lng: initial.lng };
      const destination = { lat: final.lat, lng: final.lng };

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        async (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            let directionsInfo = result.routes[0].legs[0];

            if (this.state.price && this.state.addShippingEntrega) {
              this.setState({
                price:
                  this.state.price -
                  parseFloat(this.state.priceDistanceEntrega.price),
                addShippingEntrega: false,
              });
            }

            if (this.state.price && this.state.addShippingDelivery) {
              this.setState({
                price:
                  this.state.price -
                  parseFloat(this.state.priceDistanceDelivery.price),
                addShippingDelivery: false,
              });
            }

            //Entrega
            let priceDistanceEntrega = await calculatePriceDistance(
              directionsInfo.distance.text.replace(" km", ""),
              1
            );

            this.setState({
              priceDistanceEntrega: priceDistanceEntrega,
            });

            //Delivery
            let priceDistanceDelivery = await calculatePriceDistance(
              directionsInfo.distance.text.replace(" km", ""),
              2
            );
            this.setState({
              priceDistanceDelivery: priceDistanceDelivery,
            });

            this.setState({
              directions: result,
              directionsInfo,
            });

            this.calculateReturnTax();
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }
  }

  getTotalFinal() {
    let total;
    let returnPrice;
    total = this.state.price;
    returnPrice = 0;
    if (
      this.state.addShipping &&
      (this.state.addShippingEntrega || this.state.addShippingDelivery)
    ) {
      if (this.state.addShippingEntrega) {
        total = total + parseFloat(this.state.priceDistanceEntrega.price);
      } else if (this.state.addShippingDelivery) {
        total = total + parseFloat(this.state.priceDistanceDelivery.price);
      }
    }
    if (this.state.fidelityValue.table == true) {
      total = total;
      returnPrice = 0;
    } else if (this.state.addReturnTax) {
      if (this.state.addShippingDelivery) {
        total = total + parseFloat(this.state.returnTaxDelivery.tax_price);
        returnPrice = parseFloat(this.state.returnTaxDelivery.tax_price);
      }

      if (this.state.addShippingEntrega) {
        total = total + parseFloat(this.state.returnTaxEntrega.tax_price);
        returnPrice = parseFloat(this.state.returnTaxDelivery.tax_price);
      }
    }

    let totalFormatedBRL = total.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

    this.setState({
      priceTotal: total,
      priceTotalFormatted: totalFormatedBRL,
      priceReturnTax: returnPrice,
    });

    return totalFormatedBRL;
  }

  getTotalFinalShow() {
    let total;
    total = this.state.price;

    if (
      this.state.addShipping &&
      (this.state.addShippingEntrega || this.state.addShippingDelivery)
    ) {
      if (this.state.addShippingEntrega) {
        total = total + parseFloat(this.state.priceDistanceEntrega.price);
      } else if (this.state.addShippingDelivery) {
        total = total + parseFloat(this.state.priceDistanceDelivery.price);
      }
    }

    if (this.state.fidelityValue.table == false) {
      if (this.state.addReturnTax) {
        if (this.state.addShippingDelivery) {
          total = total + parseFloat(this.state.returnTaxDelivery.tax_price);
        }

        if (this.state.addShippingEntrega) {
          total = total + parseFloat(this.state.returnTaxEntrega.tax_price);
        }
      }
    }

    let totalFormatedBRL = total.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

    return totalFormatedBRL;
  }

  getFidelityValue() {
    let fidelityTotal;
    fidelityTotal = this.state.fidelityValue.amount;

    let fidelityTotalFormatedBRL = fidelityTotal.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

    return fidelityTotalFormatedBRL;
  }

  getInfoFidelityValue() {
    let fidelityDepositAmount;
    let fidelityDepositDate;
    fidelityDepositAmount = this.state.fidelityValue.deposit_amount;
    fidelityDepositDate = this.state.fidelityValue.deposit_datetime;
    const locale = "pt-br";
    if (fidelityDepositAmount === null) {
      fidelityDepositAmount = 0;
    }

    if (fidelityDepositDate === null) {
      fidelityDepositDate = "2022-01-01T13:01:01Z";
    }
    let fidelityDepositAmountFormatedBRL = fidelityDepositAmount.toLocaleString(
      "pt-br",
      {
        style: "currency",
        currency: "BRL",
      }
    );

    let fidelityDepositDateFormatedBRL = new Date(
      fidelityDepositDate
    ).toLocaleDateString(locale);

    let returnFidelity =
      fidelityDepositAmountFormatedBRL + " - " + fidelityDepositDateFormatedBRL;

    return returnFidelity;
  }

  handleSelect = async (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        this.setState({
          initialAddress: address,
          directionsInitial: latLng,
        });
        this.setState({
          rideSolicitation: {
            ...this.state.rideSolicitation,
            lat_a: latLng.lat,
            long_a: latLng.lng,
            dep_address: address,
          },
        });
        this.updateDirections();
      })
      .catch((error) => console.error("Error", error));
  };

  handleChange2 = (finalAddress) => {
    this.setState({ finalAddress });
  };
  toggleModal() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  setFilter(e) {
    if (e.target.value.length > 0) {
      let result = this.dataFilter(this.state.tableData, e.target.value);
      this.setState({ searchResult: result });
    } else {
      this.setState({ searchResult: null });
    }
  }
  dataFilter(data, value) {
    let searched = value.toLowerCase();
    let result = [];
    data.forEach((dataItem) => {
      Object.keys(dataItem).some((key) => {
        let valueString = JSON.stringify(dataItem[key]).toLowerCase();

        if (valueString.includes(searched)) {
          result = result.concat(dataItem);
          return true;
        }
      });
    });

    return result;
  }

  filterData(data, filter) {
    return data.filter((item) => {
      return Object.keys(item).some((key) =>
        item[key].toLowerCase().includes(filter.toLowerCase())
      );
    });
  }

  componentDidMount() {
    this.updateSolicitations();
    this.updateFidelityValue();
    this.interval1 = setInterval(() => {
      this.updateSolicitations();
    }, 30000);
    this.interval2 = setInterval(() => {
      this.updateFidelityValue();
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.interval1);
    delay(200);
    clearInterval(this.interval2);
  }

  formatDate(date) {
    var data = date;
    return data.split(" ")[0];
  }

  updateSolicitations() {
    const listTemplateUrl =
      constants().URL_SERVICE + "establishment/establishment/list_templates/";

    const customConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
      },
    };
    try {
      axios.get(listTemplateUrl, customConfig).then((response) => {
        this.setState({ templatesList: response.data.templates });
      });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }
  updateFidelityValue() {
    const fidelityValueUrl =
      constants().URL_SERVICE +
      "establishment/establishment/get_info_establishment/";

    const fidelityConfig = {
      headers: {
        Authorization: "Token " + localStorage.token,
      },
    };
    try {
      axios.get(fidelityValueUrl, fidelityConfig).then((response) => {
        this.setState({ fidelityValue: response.data });
      });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }

  eraseRaceSolicitation(id) {
    const url =
      constants().URL_SERVICE + "establishment/establishment/delete_template/";
    try {
      axios
        .post(
          url,
          { id_template: id },
          { headers: { Authorization: "Token " + localStorage.token } }
        )
        .then((response) => {
          toast.success("Serviço excluído com sucesso", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // this.setState({ tableData: response.data.list });
        })
        .catch((error) => {
          this.setState({ error: true });
          toast.error("Ocorreu um Erro Durante o Cancelamento", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }
  solicitionEraseRaceSolicitation(id) {
    const url =
      constants().URL_SERVICE + "establishment/establishment/delete_template/";
    try {
      axios
        .post(
          url,
          { id_template: id },
          { headers: { Authorization: "Token " + localStorage.token } }
        )
        .catch((error) => {
          this.setState({ error: true });
          toast.error("Ocorreu um Erro Durante o Cancelamento", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } catch (_err) {
      console.error("Erro: ", _err);
    }
  }
  cancelPaymentSolicitation(id) {
    const url =
      constants().URL_SERVICE + "establishment/paymentrequest/cancel_payment/";

    axios
      .post(
        url,
        { id: id },
        { headers: { Authorization: "Token " + localStorage.token } }
      )
      .then((response) => {
        toast.success("Pagamento Cancelado com sucesso", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        // this.setState({ tableData: response.data.list });
      })
      .catch((error) =>
        toast.error("Ocorreu um Erro Durante o Cancelamento", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      );
  }

  render() {
    var options = [{ value: "2", label: "Fidelidade" }];
    const handleChange = (event, value, maskedValue) => {
      event.preventDefault();

      this.setState({
        price: value,
      });
    };
    const data = this.state.tableData;
    const filter = this.state.filter;
    const tableData = !filter ? data : this.filterData(data, filter);

    return (
      <div>
        <Modal
          isOpen={this.state.isOpen}
          contentLabel="My dialog"
          className="mymodal"
          overlayClassName="myoverlay"
          closeTimeoutMS={500}
        >
          <div className="row">
            <div style={{ paddingLeft: "0px" }} className="col-md-6">
              <div className="col-md-12">
                <div class="checkbox-section">
                  <input
                    type="checkbox"
                    onChange={() => {
                      this.setState({
                        addShipping: !this.state.addShipping,
                      });

                      setTimeout(() => {
                        this.setState({
                          initialAddress: localStorage.getItem("address"),
                          directionsInitial: {
                            lat: parseFloat(localStorage.getItem("latitude")),
                            lng: parseFloat(localStorage.getItem("longitude")),
                          },
                        });
                        this.setState({
                          rideSolicitation: {
                            ...this.state.rideSolicitation,
                            lat_a: this.state.directionsInitial.lat,
                            long_a: this.state.directionsInitial.lng,
                            dep_address: this.state.initialAddress,
                          },
                        });

                        this.updateDirections();
                      }, 300);
                    }}
                    checked={this.state.addShipping}
                  />

                  <label style={{ "margin-left": "5px" }} for="">
                    Adicionar Frete (O valor será somado ao valor final).
                  </label>
                  <br />
                  <div
                    style={{
                      display: !this.state.addShipping && "none",
                    }}
                  >
                    <div className="control-group">
                      <div className="controls ">
                        <div className="control-group">
                          <PlacesAutocomplete
                            debounce={3000}
                            highlightFirstSuggestion={true}
                            value={this.state.initialAddress}
                            onChange={this.handleChange}
                            onSelect={this.handleSelect}
                            searchOptions={{
                              location: new window.google.maps.LatLng(
                                parseFloat(localStorage.getItem("latitude")),
                                parseFloat(localStorage.getItem("longitude"))
                              ),
                              radius: 40000,
                            }}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: "Local Partida",
                                    className: "location-search-input",
                                  })}
                                  rows="2"
                                  className="form-control"
                                />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                      ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                      }
                                      : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                      };
                                    return (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>
                      </div>
                    </div>
                    <div className="control-group">
                      <div className="controls ">
                        <div className="control-group">
                          <PlacesAutocomplete
                            debounce={3000}
                            value={this.state.finalAddress}
                            onChange={this.handleChange2}
                            onSelect={this.handleSelect2}
                            searchOptions={{
                              location: new window.google.maps.LatLng(
                                parseFloat(localStorage.getItem("latitude")),
                                parseFloat(localStorage.getItem("longitude"))
                              ),
                              radius: 40000,
                            }}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: "Local Final",
                                    className: "location-search-input",
                                  })}
                                  autoFocus
                                  className="form-control"
                                />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                      ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                      }
                                      : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                      };
                                    return (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                                <label
                                  label-default=""
                                  className="control-label"
                                >
                                  Observação
                                </label>
                                <textarea
                                  className="form-control"
                                  autoComplete="off"
                                  onChange={this.handleNotes}
                                  value={this.state.noteInput}
                                  title="Insira a observação que será mostrada."
                                  required
                                  rows="1"
                                  ref="description"
                                />
                              </div>
                            )}
                          </PlacesAutocomplete>

                          <div class="row">
                            <div class="col-md-7">
                              <br />
                              <label
                                for=""
                                style={{
                                  "font-weight": "bold",
                                }}
                              >
                                Escolha abaixo o tipo de frete.
                              </label>
                              <br />
                              <div className="card-solicitation-checkboxes">
                                <div>
                                  <input
                                    type="checkbox"
                                    onChange={() => {
                                      this.setState({
                                        addShippingEntrega:
                                          !this.state.addShippingEntrega,
                                        addShippingDelivery: false,
                                      });
                                      this.setState({
                                        rideSolicitation: {
                                          ...this.state.rideSolicitation,
                                          service_type: 1,
                                        },
                                      });
                                      this.calculateReturnTax();
                                    }}
                                    checked={this.state.addShippingEntrega}
                                  />
                                  <label
                                    style={{
                                      "margin-left": "5px",
                                      "font-size": 16,
                                    }}
                                    for=""
                                  >
                                    Entrega:{" "}
                                    {this.state.directionsInfo &&
                                      this.state.priceDistanceEntrega
                                        .price_monetary}
                                  </label>
                                </div>
                              </div>

                              <span for="">
                                Distancia:{" "}
                                {this.state.directionsInfo &&
                                  this.state.directionsInfo.distance.text}
                                Tempo:{" "}
                                {this.state.directionsInfo &&
                                  this.state.directionsInfo.duration.text}
                              </span>
                              <br />
                              {(this.state.addShippingDelivery ||
                                this.state.addShippingEntrega) && (
                                  <div className="card-solicitation-checkboxes">
                                    <div>
                                      <input
                                        type="checkbox"
                                        onChange={() => {
                                          this.setState({
                                            addReturnTax:
                                              !this.state.addReturnTax,
                                          });
                                        }}
                                        checked={this.state.addReturnTax}
                                      />
                                      <label
                                        style={{ "margin-left": "5px" }}
                                        for=""
                                      >
                                        Adicionar retorno (
                                        {this.state.addReturnTax === true ? (
                                          <text>Sim</text>
                                        ) : (
                                          <text>Não</text>
                                        )}
                                        )
                                      </label>
                                    </div>
                                  </div>
                                )}
                              <h3>
                                Valor total:{" "}
                                {this.state.directionsInfo &&
                                  this.getTotalFinalShow()}
                              </h3>
                            </div>
                            <div style={{ marginTop: "25px" }} class="col-md-5">
                              <br />
                              <div className="card-solicitation-checkboxes">
                                <div>
                                  <input
                                    type="checkbox"
                                    onChange={() => {
                                      this.setState({
                                        addShippingDelivery:
                                          !this.state.addShippingDelivery,
                                        addShippingEntrega: false,
                                      });
                                      this.setState({
                                        rideSolicitation: {
                                          ...this.state.rideSolicitation,
                                          service_type: 2,
                                        },
                                        // showIDPURDialog: true
                                      });
                                      this.calculateReturnTax();
                                    }}
                                    checked={this.state.addShippingDelivery}
                                  />

                                  <label
                                    style={{
                                      "margin-left": "5px",
                                      "font-size": 16,
                                    }}
                                    for=""
                                  >
                                    Delivery:{" "}
                                    {this.state.directionsInfo &&
                                      this.state.priceDistanceDelivery
                                        .price_monetary}
                                  </label>
                                </div>
                              </div>
                              {(this.state.addShippingDelivery ||
                                this.state.addShippingEntrega) && (
                                  <div
                                    style={{ marginTop: "24px" }}
                                    className="card-solicitation-checkboxes"
                                  >
                                    <div>
                                      <input
                                        type="checkbox"
                                        onChange={() => {
                                          this.setState({
                                            addHaveMachine:
                                              !this.state.addHaveMachine,
                                          });
                                        }}
                                        checked={this.state.addHaveMachine}
                                      />
                                      <label
                                        style={{ "margin-left": "5px" }}
                                        for=""
                                      >
                                        Maquina
                                      </label>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="control-group">
                <div className="controls">
                  <div style={{ marginLeft: "0px" }} className="row">
                    <label
                      style={{ marginLeft: "15px" }}
                      label-default=""
                      className="control-label"
                    >
                      ID Motorista
                    </label>
                    <div
                      style={{ width: "100%", display: "flex" }}
                      className="col-md-12"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <input
                          style={{ width: "60%", marginTop: "30px" }}
                          type="number"
                          className="form-control"
                          onChange={this.handleAPI}
                          autocomplete="off"
                          title="Insira o ID do motorista"
                          rows="1"
                          ref="driverid"
                          value={this.state.iddriver}
                        />
                        {/* <Select
                        placeholder="Tipo de pagamento"
                        searchable={false}
                        value={this.state.brandSelect}
                        onChange={this._onChange.bind(this)}
                        options={options}
                      /> */}
                      </div>
                      {this.state.allDrivers.map((res) => {
                        return (
                          <div>
                            {res.id == this.state.iddriver ? (
                              <div
                                style={{ borderBottom: "none" }}
                                className="card-driver-content"
                              >
                                <img
                                  src={res.profile_picture || perfilDefault}
                                  width="80"
                                  height="80"
                                  onError={(e) => {
                                    if (e.target.src !== perfilDefault) {
                                      e.target.src = perfilDefault;
                                    }
                                  }}
                                  alt="Foto do perfil"
                                />
                                <div className="card-driver-text">
                                  <text className="font-bold">ID: </text>
                                  <text>{res.id}</text> <br />
                                  <text className="font-bold">Nome: </text>
                                  <text>{res.label} </text> <br />
                                  <text className="font-bold">Celular: </text>
                                  <text>{res.phone} </text> <br />
                                </div>
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                    {/* <div className="col-md-4">
                            <label label-default="" className="control-label">
                              Id do Pedido
                            </label>
                            <input
                              type="number"
                              name="numberOfGuests"
                              className="form-control"
                              // pattern='[0-9]{0,5}'
                              onChange={(value) => {
                                this.setState({
                                  purchase_id: value.target.value,
                                });
                              }}
                              value={this.state.purchase_id}
                            />
                          </div> */}
                  </div>
                </div>
              </div>

              {/* <div className="control-group">
                      <div className="controls">
                        <div className="row">
                          <div className="col-md-6">
                            <label label-default="" className="control-label">
                              Id do Pedido
                            </label>
                            <input
                                type='number'
                                name="numberOfGuests"
                                className='form-control'
                                // pattern='[0-9]{0,5}'
                                onChange={value => {
                                  this.setState({ purchase_id: value.target.value });
                                }}
                                value={this.state.purchase_id}
                            />

                          </div>

                        </div>
                      </div>
                    </div> */}

              <div className="control-group">
                <div className="controls">
                  <div className="control-group">
                    <label label-default="" className="control-label"></label>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-md-6"
              style={{ display: !this.state.addShipping && "none" }}
            >
              <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCHAJKwsNnBiAHVlCPZe59h024ynGRvjOg&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `460px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                zoom={0}
                directions={this.state.directions}
              />
            </div>
          </div>
          <div className="card-solicitation-buttons">
            <Link
              style={{ padding: "5px" }}
              type="button"
              className="btn btn-danger btn-lg"
              onClick={() => {
                this.setState({ isOpen: false });
                delay(200);
                this.clearAll();
              }}
            >
              Cancelar
            </Link>
            {this.state.directionsInfo && (
              <div>
                <Link
                  type="button"
                  style={{ marginLeft: "70px", padding: "5px" }}
                  className="btn btn-info btn-lg"
                  onClick={async () => {
                    await this.getTotalFinal();
                    await this.setState({
                      rideSolicitation: {
                        ...this.state.rideSolicitation,
                        lat_a: this.state.directionsInitial.lat,
                        long_a: this.state.directionsInitial.lng,
                        dep_address: this.state.initialAddress,
                        note: this.state.noteInput,
                        price: this.state.priceTotal,
                        distance: this.state.directionsInfo.distance.text,
                        price_monetary: this.state.priceTotalFormatted,
                        driver_requested_id:
                          this.state.driverData &&
                            this.state.driverData.length != 0
                            ? parseInt(this.state.driverData[0].id)
                            : null,
                        driver_data: this.state.driverData,
                        have_machine: this.state.addHaveMachine,
                        tax_price: this.state.priceReturnTax,
                        template_directions: this.state.directions,
                        directions_info: this.state.directionsInfo,
                        price_distance_entrega: this.state.priceDistanceEntrega,
                        price_distance_delivery:
                          this.state.priceDistanceDelivery,
                        shipping_delivery: this.state.addShippingDelivery,
                        shipping_entrega: this.state.addShippingEntrega,
                        return_tax_entrega: this.state.returnTaxEntrega,
                        return_tax_delivery: this.state.returnTaxDelivery,
                        has_return_tax: this.state.addReturnTax,
                      },
                    });
                    if (
                      this.state.iddriver !== "" &&
                      this.state.iddriver !== null &&
                      (this.state.driverData === null ||
                        this.state.driverData == [] ||
                        this.state.driverData === "")
                    ) {
                      toast.error(
                        "Erro: Aguarde o carregamento dos dados do motorista ou insira o ID novamente!",
                        {
                          position: "top-right",
                          autoClose: 3000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                        }
                      );
                      this.setState({ templateId: 0 });
                    } else {
                      if (this.state.templateId === 0) {
                        await this.saveJson();
                      } else {
                        await this.editJson();
                      }
                    }
                    this.setState({ isOpen: false });
                    delay(200);
                    this.clearAll();
                  }}
                >
                  Salvar
                </Link>
                <Link
                  type="button"
                  style={{ marginLeft: "70px", padding: "5px" }}
                  className="btn btn-success btn-lg"
                  onClick={async () => {
                    this.disableButton();
                    await this.getTotalFinal();
                    await this.setState({
                      rideSolicitation: {
                        ...this.state.rideSolicitation,
                        note: this.state.noteInput,
                        price: this.state.priceTotal,
                        distance: this.state.directionsInfo.distance.text,
                        price_monetary: this.state.priceTotalFormatted,
                        driver_requested_id: parseInt(this.state.iddriver),
                        tax_price: this.state.priceReturnTax,
                        have_machine: this.state.addHaveMachine,
                        has_return_tax: this.state.addReturnTax,
                      },
                    });
                    await this.requestJson();
                    if (this.state.templateId != 0) {
                      this.eraseRaceSolicitation(this.state.templateId);
                      delay(200);
                      await this.setState({ templateId: 0 });
                    }
                    this.setState({ isOpen: false });
                    delay(200);
                    this.clearAll();
                  }}
                >
                  Solicitar
                </Link>
              </div>
            )}
          </div>
        </Modal>
        <BarTitle name="Solicitações" />
        <div className="wrapper-md">
          <div className="panel panel-default">
            <div
              className="panel-heading"
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <text className="font-bold">Origem: </text>
                <text>{localStorage.getItem("address")}</text>
                <br />
                <text className="font-bold">Valor Adicionado: </text>

                <text>
                  {this.state.fidelityValue && this.getInfoFidelityValue()}
                </text>
              </div>
              <div>
                <text className="font-bold">Saldo: </text>

                <text>
                  {this.state.fidelityValue && this.getFidelityValue()}
                </text>
                <Link
                  style={{ marginLeft: "30px" }}
                  disabled={this.state.disabled}
                  data-toggle="modal"
                  data-target=".bd-example-modal-lg"
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    this.disableButton();
                    delay(100);
                    this.requestAll();
                  }}
                >
                  Solicitar Todas
                </Link>
                <Link
                  style={{ marginLeft: "10px" }}
                  data-toggle="modal"
                  data-target=".bd-example-modal-lg"
                  type="button"
                  className="btn btn-info"
                  onClick={() => {
                    this.setState({ isOpen: true });
                  }}
                >
                  Adicionar entrega
                </Link>
              </div>
            </div>
            <div className="panel-body">
              <div className="card-main-container">
                {this.state.templatesList.length > 0
                  ? this.state.templatesList.map((solicition, i) => (
                    <div className="card-main">
                      <div className="card-title font-bold">
                        ENTREGA {i + 1}
                      </div>
                      <div className="card-content">
                        <div>
                          <text className="font-bold">Destino: </text>
                          <text>{solicition.json.arr_address} </text>
                          <br />
                          <text className="font-bold">KM: </text>
                          <text>{solicition.json.distance} </text> <br />
                          <text className="font-bold">Valor do Frete: </text>
                          <text> {solicition.json.price_monetary} </text>{" "}
                          <br />
                          {solicition.json.has_return_tax === false ? (
                            <div>
                              <text className="font-bold">Retornar: </text>
                              <text> Não </text> <br />
                            </div>
                          ) : (
                            <div>
                              <text className="font-bold">Retornar: </text>
                              <text> Sim </text>
                              <br />
                            </div>
                          )}
                          {solicition.json.have_machine == true ? (
                            <div>
                              <text className="font-bold">Maquina: </text>
                              <text> Sim </text> <br />
                            </div>
                          ) : (
                            <div>
                              <text className="font-bold">Maquina: </text>
                              <text> Não </text>
                            </div>
                          )}
                          <text className="font-bold">Observação: </text>
                          <text> {solicition.json.note} </text> <br />
                        </div>
                      </div>
                      {solicition.json.driver_requested_id == 0 ||
                        solicition.json.driver_requested_id == null ? (
                        <div className="card-no-driver-content">
                          <text style={{ position: "relative", top: "10px" }}>
                            Corrida sem ID. Vamos procurar um motorista para
                            essa corrida.
                          </text>
                        </div>
                      ) : (
                        <div className="card-driver-content">
                          <img
                            src={solicition.json.driver_data[0].profile_picture || perfilDefault}
                            width="80"
                            height="80"
                            onError={(e) => {
                              if (e.target.src !== perfilDefault) {
                                e.target.src = perfilDefault;
                              }
                            }}
                            alt="Foto do perfil"
                          />
                          <div className="card-driver-text">
                            <text className="font-bold">ID: </text>
                            <text>
                              {solicition.json.driver_data[0].id}
                            </text>{" "}
                            <br />
                            <text className="font-bold">Nome: </text>
                            <text>
                              {solicition.json.driver_data[0].label}{" "}
                            </text>{" "}
                            <br />
                            <text className="font-bold">Celular: </text>
                            <text>
                              {solicition.json.driver_data[0].phone}{" "}
                            </text>{" "}
                            <br />
                          </div>
                        </div>
                      )}
                      <div className="card-driver-buttons">
                        <Link
                          type="button"
                          className="btn btn-danger btn-lg"
                          onClick={() => {
                            this.eraseRaceSolicitation(solicition.id);
                          }}
                        >
                          Excluir
                        </Link>
                        <Link
                          type="button"
                          className="btn btn-info btn-lg"
                          onClick={() => {
                            this.setState({
                              addHaveMachine: solicition.json.have_machine,
                              driverData: solicition.json.driver_data,
                              price: 0,
                              priceTotal: solicition.json.price,
                              priceTotalFormatted: solicition.json.price,
                              priceReturnTax: solicition.json.tax_price,
                              iddriver:
                                solicition.json.driver_data &&
                                  solicition.json.driver_data.length != 0
                                  ? solicition.json.driver_data[0].id
                                  : null,
                              noteInput: solicition.json.note,
                              purchase_id: 0,
                              directions: solicition.json.template_directions,
                              addShipping: true,
                              addShippingEntrega:
                                solicition.json.shipping_entrega,
                              addShippingDelivery:
                                solicition.json.shipping_delivery,
                              directionsInitial: {
                                lat: solicition.json.lat_a,
                                lng: solicition.json.long_a,
                              },
                              directionsFinal: {
                                lat: solicition.json.lat_b,
                                lng: solicition.json.long_b,
                              },
                              directionsInfo: solicition.json.directions_info,
                              priceDistanceEntrega:
                                solicition.json.price_distance_entrega,
                              priceDistanceDelivery:
                                solicition.json.price_distance_delivery,
                              initialAddress: solicition.json.dep_address,
                              finalAddress: solicition.json.arr_address,
                              returnTaxEntrega:
                                solicition.json.return_tax_entrega,
                              returnTaxDelivery:
                                solicition.json.return_tax_delivery,
                              templateId: solicition.id,
                            });
                            this.setState({
                              rideSolicitation: {
                                have_machine: solicition.json.have_machine,
                                arr_address: solicition.json.arr_address,
                                dep_address: solicition.json.dep_address,
                                lat_a: solicition.json.lat_a,
                                long_a: solicition.json.long_a,
                                lat_b: solicition.json.lat_b,
                                long_b: solicition.json.long_b,
                                object_size: solicition.json.object_size,
                                payment_method:
                                  solicition.json.payment_method,
                                service_type: solicition.json.service_type,
                                note: solicition.json.note,
                                price: solicition.json.price,
                                distance:
                                  solicition.json.directions_info.distance
                                    .text,
                                price_monetary:
                                  solicition.json.price_monetary,
                                driver_requested_id: solicition.json
                                  .driver_data
                                  ? solicition.json.driver_data[0].id
                                  : null,
                                driver_data: solicition.json.driver_data
                                  ? solicition.json.driver_data[0]
                                  : null,
                                tax_price: solicition.json.tax_price,
                              },
                            });
                            this.setState({ isOpen: true });
                          }}
                        >
                          Editar
                        </Link>
                        <button
                          type="button"
                          disabled={this.state.disabled}
                          className="btn btn-success btn-lg"
                          onClick={async () => {
                            this.disableButton();

                            await this.setState({
                              savedRideSolicitation: {
                                arr_address: solicition.json.arr_address,
                                dep_address: solicition.json.dep_address,
                                driver_requested_id:
                                  solicition.json.driver_requested_id,
                                lat_a: solicition.json.lat_a,
                                lat_b: solicition.json.lat_b,
                                long_a: solicition.json.long_a,
                                long_b: solicition.json.long_b,
                                object_size: solicition.json.object_size,
                                payment_method:
                                  solicition.json.payment_method,
                                note: solicition.json.note,
                                price: solicition.json.price,
                                price_monetary:
                                  solicition.json.price_monetary,
                                service_type: solicition.json.service_type,
                                tax_price: solicition.json.tax_price,
                                have_machine: solicition.json.have_machine,
                                has_return_tax:
                                  solicition.json.has_return_tax,
                              },
                            });

                            await this.requestSavedJson(solicition.id);
                          }}
                        >
                          Solicitar
                        </button>
                      </div>
                    </div>
                  ))
                  : //     <div className="no-result">
                  //     <h3>Nenhum resultado encontrado</h3>
                  // </div>
                  null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RaceSolicitation;



// WEBPACK FOOTER //
// ./src/views/RaceSolicitation/index.js